import React from "react";
import bajaj from '../../../assets/slider/bajaj.jpg'
import hero from '../../../assets/slider/hero.jpg'
import runner from '../../../assets/slider/runner.jpg'
import suzuki from '../../../assets/slider/suzuki.jpg'

const Banner = () => {
  return (
    <div className="lg:mt-10">
        <div className="carousel w-full">
            <div id="item1" className="carousel-item w-full">
                <img src={bajaj} className="w-full lg:h-[550px]" alt="" />
            </div> 
            <div id="item2" className="carousel-item w-full">
                <img src={hero} className="w-full lg:h-[550px]" alt="" />
            </div> 
            <div id="item3" className="carousel-item w-full">
                <img src={runner} className="w-full lg:h-[550px]" alt="" />
            </div> 
            <div id="item4" className="carousel-item w-full">
                <img src={suzuki} className="w-full lg:h-[550px]" alt="" />
            </div>
        </div> 
        <div className="flex justify-center w-full py-2 gap-2">
            <a href="#item1" className="btn btn-md">1</a> 
            <a href="#item2" className="btn btn-md">2</a> 
            <a href="#item3" className="btn btn-md">3</a> 
            <a href="#item4" className="btn btn-md">4</a>
        </div>
    </div>
  );
};

export default Banner;
